import type { GetEmployeeScheduleResponse, Slot } from "../types/types";

export function getAllAvailableSlots(data: GetEmployeeScheduleResponse | undefined): Slot[] {
  if (!data) return [];

  const seen = new Set<string>();
  const result: Slot[] = [];

  for (const emp of data.employees) {
    for (const slot of emp.slots) {
      const key = `${slot.start}-${slot.end}`; // уникальность по паре start/end
      if (!seen.has(key)) {
        seen.add(key);
        result.push({ start: slot.start, end: slot.end });
      }
    }
  }

  // отсортируем по времени начала
  result.sort((a, b) => (a.start > b.start ? 1 : a.start < b.start ? -1 : 0));

  return result;
}
